import React, { PropsWithChildren } from "react"
import {
  LabelContext,
  LabelProps,
  useContextProps,
} from "react-aria-components"

const Label = React.forwardRef(
  (
    props: PropsWithChildren<LabelProps>,
    ref: React.ForwardedRef<HTMLLabelElement>
  ) => {
    const [ctx, forwardedRef] = useContextProps(props, ref, LabelContext)
    delete ctx.elementType // Select seems to be adding an elementType=span on the label for some reason
    return (
      <label {...ctx} ref={forwardedRef}>
        <span>{props.children}</span>
      </label>
    )
  }
)

export default Label
